import Vue from "vue";

import GcGenerateSalesOrderFromContractLine from "./gc-popup-generate-sales-order from-contract-line";
import GcGenerateSalesOrder from "./gc-popup-generate-sales-order";
import GcItemPriceUpdate from "./gc-popup-item-price-update";
import GcAccountStatusModal from "./gc-popup-account-status-modal";
import GcStockLevels from "./gc-popup-stock-levels";
import GcPopUpAlmondcoDespatchData from "./gc-popup-almondco-despatch-data";
import GcPopUpEditProductItem from "./gc-popup-edit-product-item";
import GcPopUpAddSalesOrderItem from "./gc-popup-add-sales-order-item";
import GcPopUpSearchForItem from "./gc-popup-search-for-item";
import GcPopupLinkAnItem from "./gc-popup-link-an-item";
import GcSundryTransactionPopup from "./gc-popup-sundry-transaction-model";
import GcPopupGeneralDataGrid from "./gc-popup-general-data-grid";
import GcPopupCustomerStatement from "./gc-popup-customer-statement";
import GcPopupRoamDespatchBatch from "./roam/gc-popup-roam-despatch-order-batch-details";
import GcPopupSoPayNow from "./gc-popup-so-pay-now";
import GcPopupSoPartPick from "./gc-popup-so-part-pick"
import GcPopupProductKits from "./gc-popup-product-kits"
import GcPopupBankFee from "./gc-popup-bank-fee"
import GcPopupBankTransfer from "./gc-popup-bank-transfer"
import GcPopupDepositClaim from "./gc-popup-deposit-claim";
import GcPopupImagePreview from "./gc-popup-image-preview"
import GcPopupSchedulerCallLog from "./gc-popup-call-scheduler-call-log";
import GcPopUpSearchForMultipleItem from "./gc-popup-search-for-multiple-item";
import GcPopUpWorkOrder from "./gc-popup-work-order";

// Touch
import GcPopUpSelectRecord from "./touch/gc-popup-select-record";

export function RegisterPopUpComponents() {
  // eslint-disable-next-line no-console
  // this.$logger.debug("Registering devexpress components globally");

  Vue.component(
    "GcGenerateSalesOrderFromContractLine",
    GcGenerateSalesOrderFromContractLine
  );
  Vue.component("GcGenerateSalesOrder", GcGenerateSalesOrder);
  Vue.component("GcItemPriceUpdate", GcItemPriceUpdate);
  Vue.component("GcAccountStatusModal", GcAccountStatusModal);
  Vue.component("GcStockLevels", GcStockLevels);
  Vue.component("GcPopUpAlmondcoDespatchData", GcPopUpAlmondcoDespatchData);
  Vue.component("GcPopUpEditProductItem", GcPopUpEditProductItem);
  Vue.component("GcPopUpAddSalesOrderItem", GcPopUpAddSalesOrderItem);
  Vue.component("GcPopUpSearchForItem", GcPopUpSearchForItem);
  Vue.component("GcPopupLinkAnItem", GcPopupLinkAnItem);
  Vue.component("GcPopupGeneralDataGrid", GcPopupGeneralDataGrid);
  Vue.component("GcSundryTransactionPopup", GcSundryTransactionPopup);
  Vue.component("GcPopupCustomerStatement", GcPopupCustomerStatement);
  Vue.component("GcPopUpSelectRecord", GcPopUpSelectRecord);
  Vue.component("GcPopupRoamDespatchBatch", GcPopupRoamDespatchBatch);
  Vue.component("GcPopupSoPayNow", GcPopupSoPayNow);
  Vue.component("GcPopupSoPartPick", GcPopupSoPartPick);
  Vue.component("GcPopupProductKits", GcPopupProductKits);
  Vue.component("GcPopupBankFee", GcPopupBankFee);
  Vue.component("GcPopupBankTransfer", GcPopupBankTransfer);
  Vue.component("GcPopupDepositClaim", GcPopupDepositClaim);
  Vue.component("GcPopupImagePreview", GcPopupImagePreview);
  Vue.component("GcPopupSchedulerCallLog", GcPopupSchedulerCallLog);
  Vue.component("GcPopUpSearchForMultipleItem", GcPopUpSearchForMultipleItem);
  Vue.component("GcPopUpWorkOrder", GcPopUpWorkOrder);
}
